import Blog from "@/Layouts/Blog";
import Hero from "@/Sections/Hero";
import { Head } from "@inertiajs/inertia-react";
import Contact from "@/Sections/Contact";

import { PaperClipIcon } from "@heroicons/react/solid";

export default function AboutPage() {
    return (
        <Blog>
            <Head>
                <title>
                    Bedrijfsfitness - WE ARE Personal Training Uden en Schijndel
                </title>
                <link rel="canonical" href={route("course.company-fitness")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta
                    property="og:description"
                    content="Jouw transformatie binnen 12 weken? Bij WE ARE personal training Uden en Schijndel regelen we het! Geen resultaat = geld terug!"
                />
                <meta
                    property="og:url"
                    content={route("course.company-fitness")}
                />
                <meta property="og:type" content="website" />
                <meta
                    property="og:title"
                    content="Bedrijfsfitness - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/personal-training-uden-schijndel.png"
                />
            </Head>

            <div className="bg-black">
                <Hero homepage={false} header={"Bedrijfsfitness"}></Hero>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="overflow-hidden">
                        <h2 className="block text-white  text-center mx-auto font-custom italic font-bold uppercase max-w-4xl xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl mt-8">
                            Een individuele aanpak voor vitalere werknemers
                        </h2>

                        <div className="mx-auto max-w-7xl px-6 lg:px-8 pt-24">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Individuele trajecten voor{" "}
                                <span className="text-we-are-yellow">
                                    duurzame gezondheid
                                </span>
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Bij WE ARE bieden wij complete individuele
                                trajecten aan voor uw werknemers die een
                                aanzienlijk risico vormen voor uw verzuimkosten.
                                In een zorgvuldig opgezet programma van zes
                                maanden werken we aan het opbouwen van een
                                gezonde leefstijl, waarbij voeding, training en
                                mentale ontwikkeling centraal staan. Met behulp
                                van een half jaar programma transformeert uw
                                medewerker in uw fitste medewerker ooit!
                            </p>
                            {/*  */}
                            <p className="mt-10 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Een alomvattende benadering
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                WE ARE richt zich op alle factoren die van
                                invloed zijn op zowel de persoonlijke als
                                professionele resultaten, zowel op korte als
                                lange termijn. Een cruciaal inzicht hierbij is
                                de verdeling van de 168 uur in een week:
                            </p>
                            {/* TODO: Hier zijn we gebleven */}
                            <ul className="mt-6 text-lg leading-8 text-white list-disc">
                                <li>Volledige week: 168 uur</li>
                                <li>Slapen: 56 uur</li>
                                <li>Sporten: 1-5 uur</li>
                                <li>Overige uren: 107 uur</li>
                            </ul>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Conventionele bedrijfsfitnessprogramma's, zoals
                                het nationale bedrijfsfitness, bieden werkgevers
                                de mogelijkheid om hun werknemers te laten
                                sporten in reguliere sportscholen. Deze aanpak
                                heeft echter een aantal beperkingen:
                            </p>
                            <ol className="mt-6 text-lg leading-8 text-white list-decimal">
                                <li>
                                    Er wordt geen rekening gehouden met de
                                    resterende 107 uur in de week (63,7% van de
                                    totale tijd).
                                </li>
                                <li>
                                    Het ontbreekt aan commitment en begeleiding.
                                </li>
                                <li>
                                    De vrijblijvendheid leidt vaak tot beperkte
                                    resultaten.
                                </li>
                            </ol>
                            <p className="mt-6 text-lg leading-8 text-white">
                                WE ARE - Bedrijfsfitness onderscheidt zich door
                                zich te richten op de volledige 168 uur in de
                                week. Deze holistische benadering vergroot de
                                kans op succes aanzienlijk.
                            </p>
                        </div>
                    </div>

                    <div className="overflow-hidden py-12">
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                <span className="text-we-are-yellow">
                                    Gestructureerde
                                </span>{" "}
                                aanpak in fasen
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white"></p>
                            <ul className="mt-6 text-lg leading-8 text-white list-disc">
                                <li>
                                    Elke nieuwe fase van vier weken start met
                                    een meting van de werknemers (gewicht,
                                    buikomvang en foto's).
                                </li>
                                <li>
                                    Voor aanvang van het project wordt een
                                    informatiebijeenkomst georganiseerd.
                                </li>
                                <li>
                                    Na fase 6 is er de mogelijkheid om een
                                    resultaatviering te organiseren voor uw
                                    medewerker.
                                </li>
                                <li>
                                    Alle deelnemers ontvangen: De WE ARE
                                    kookboeken, Onbeperkte toegang tot
                                    maandelijkse masterclasses, Het boek
                                    'Succesvol afvallen zonder voedingsschema'
                                </li>
                            </ul>
                        </div>

                        <div className="mx-auto max-w-7xl px-6 lg:px-8 my-24 xs:my-8 sm:my-8 md:my-24 lg:my-24">
                            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                                <div>
                                    <img
                                        src="/assets/business/specialistische-begeleiding.jpg"
                                        alt="Bedrijfsfitness coach"
                                        className="w-full"
                                    />
                                </div>
                                <div>
                                    <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                        <span className="text-we-are-yellow">
                                            Specialistische
                                        </span>{" "}
                                        begeleiding
                                    </p>
                                    <p className="mt-6 text-lg leading-8 text-white">
                                        Onze aanpak is gebaseerd op
                                        wetenschappelijk onderbouwde methoden en
                                        wordt uitgevoerd door gekwalificeerde
                                        professionals. Elke deelnemer krijgt een
                                        persoonlijke coach toegewezen die hen
                                        gedurende het hele traject begeleidt en
                                        motiveert.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-24 xs:mt-8 sm:mt-8 md:mt-16 lg:mt-16">
                            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                                <div>
                                    <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                        <span className="text-we-are-yellow">
                                            Maatwerk
                                        </span>{" "}
                                        voor uw organisatie
                                    </p>
                                    <p className="mt-6 text-lg leading-8 text-white">
                                        Wij begrijpen dat elke organisatie uniek
                                        is. Daarom bieden wij de mogelijkheid om
                                        het programma aan te passen aan de
                                        specifieke behoeften en cultuur van uw
                                        bedrijf. Zo creëren we een optimale fit
                                        tussen onze aanpak en uw
                                        organisatiedoelstellingen.
                                    </p>
                                </div>
                                <div>
                                    <img
                                        src="/assets/business/maatwerk-organisatie.jpg"
                                        alt="Bedrijfsfitness maatwerk"
                                        className="w-full"
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="mx-auto max-w-7xl px-6 lg:px-8 mt-24 xs:mt-8 sm:mt-8 md:mt-16 lg:mt-16">
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Start{" "}
                                <span className="text-we-are-yellow">
                                    vandaag
                                </span>{" "}
                                nog
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Door te kiezen voor WE ARE - Bedrijfsfitness,
                                investeert u in een programma dat verder gaat
                                dan traditionele fitnessconcepten. U biedt uw
                                werknemers een kans om hun levensstijl
                                fundamenteel te verbeteren, wat niet alleen
                                leidt tot persoonlijke groei, maar ook tot
                                verhoogde productiviteit en verminderd
                                ziekteverzuim. Investeer in de toekomst van uw
                                bedrijf met WE ARE - Bedrijfsfitness. Want
                                gezonde werknemers zijn de sleutel tot een
                                gezonde organisatie.
                            </p>
                            <p className="mt-6 text-lg leading-8 text-white">
                                Voor meer gedetailleerde informatie kunt u onze
                                informatiebrochure downloaden via de
                                onderstaande knop. Bij vragen staat ons team
                                altijd voor u klaar. Samen werken we aan fittere
                                en gezondere werknemers!
                            </p>
                            <a
                                href="/assets/bedrijfsfitness-brochure.pdf"
                                target="_blank"
                                className="mt-6 inline-flex items-center text-we-are-yellow font-medium bg-we-are-purple rounded-md px-4 py-2 text-lg"
                            >
                                <PaperClipIcon className="h-6 w-6 text-white" />
                                <span className="ml-2 text-white">
                                    Download de brochure
                                </span>
                            </a>
                        </div>
                    </div>
                </div>

                <Contact />
            </div>
        </Blog>
    );
}
